<template>
  <div id="app">
    <component :is="layout" :isLight="color">
      <router-view :key="$route.fullPath" />
    </component>
  </div>
</template>

<script>
const default_layout = "default";

export default {
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
    color() {
      return this.$route.meta.isLight || false;
    }
  },

  created() {
  },

  updated() {
    // something defined here whatever the this.$route.path
  }
};
</script>


<style lang="scss">
@import "@/assets/style/styles.scss";
</style>